// export const SERVER_ADDRESS: string = "https://localhost:1234/";
import { EN_TRANSLATIONS, ES_TRANSLATIONS, FR_TRANSLATIONS, PT_TRANSLATIONS, Translations } from "./translations";

// Функция для определения языка по домену
function getLanguageByDomain(): 'en' | 'es' | 'fr' | 'pt' {
  const hostname = window.location.hostname;
  
  // Если домен содержит tves.club или tves.top - испанский
  if (hostname.includes('tves.club') || hostname.includes('tves.top')) {
    return 'es';
  }
  
  // Если домен содержит tvfran.top - французский
  if (hostname.includes('tvfran.top')) {
    return 'fr';
  }
  
  // Если домен содержит tvport.top - португальский
  if (hostname.includes('tvport.top')) {
    return 'pt';
  }
  
  // По умолчанию английский (для arctv.app и других)
  return 'en';
}

// Определяем сервер в зависимости от домена
function getServerAddress(): string {
  const hostname = window.location.hostname;
  
  if (hostname.includes('tves.club')) {
    return "https://tves.club/";
  }
  
  if (hostname.includes('tves.top')) {
    return "https://tves.top/";
  }
  
  if (hostname.includes('tvfran.top')) {
    return "https://tvfran.top/";
  }
  
  if (hostname.includes('tvport.top')) {
    return "https://tvport.top/";
  }
  
  if (hostname.includes('sctv.club')) {
    return "https://sctv.club/";
  }
  
  if (hostname.includes('screenifymsx.web.app')) {
    return "https://screenifymsx.web.app/";
  }
  
  return "https://arctv.app/";
}

export const SERVER_ADDRESS: string = getServerAddress();

export const IMAGES_PROXY: string = "https://default-4fgwt4kygq-uc.a.run.app/";

// Функция для определения региона по домену
export function getRegionByDomain(): string {
  const hostname = window.location.hostname;
  
  // Если домен содержит tves.top - регион mexico
  if (hostname.includes('tves.top')) {
    return 'mexico';
  }
  
  // Если домен содержит tves.club - регион spain (или другой испанский регион)
  if (hostname.includes('tves.club')) {
    return 'spain';
  }
  
  // Если домен содержит tvfran.top - регион france
  if (hostname.includes('tvfran.top')) {
    return 'france';
  }
  
  // Если домен содержит tvport.top - регион brazil
  if (hostname.includes('tvport.top')) {
    return 'brazil';
  }
  
  // По умолчанию global
  return 'global';
}

// Функция для получения текущих переводов
function getTranslations(): Translations {
  const language = getLanguageByDomain();
  if (language === 'es') {
    return ES_TRANSLATIONS;
  } else if (language === 'fr') {
    return FR_TRANSLATIONS;
  } else if (language === 'pt') {
    return PT_TRANSLATIONS;
  }
  return EN_TRANSLATIONS;
}

export const res_backgroundJPG = `${SERVER_ADDRESS}data/background.jpg`;
export const res_login_background = `${SERVER_ADDRESS}data/login_background.png#msx-keep-ratio`;
export const res_search_background = `${SERVER_ADDRESS}data/search_background.png#msx-keep-ratio`;
export const res_logo = `${SERVER_ADDRESS}data/logo.png`;
export const empty_account_avatar = `${SERVER_ADDRESS}data/account.png`;

//for developing
// Маппинг названий студий к их imdbid из API
export let studioIdMap: Map<string, string> = new Map([
  ["Netflix", "co0144901"],
  ["Amazon Prime Video", "co0144902"], // Нужно получить реальный ID
  ["HBO Max", "co0144903"], // Нужно получить реальный ID
  ["Disney+", "co0144904"], // Нужно получить реальный ID
  ["Apple TV+", "co0144905"], // Нужно получить реальный ID
]);

export let serviceMap: Map<string, string> = new Map([
  ["Netflix", "https://streamanflow.one/studioImage/netflix.svg"],
  [
    "Amazon Prime Video",
    "https://screenify.fun/_next/image?url=https%3A%2F%2Fstreamanflow.one%2FstudioImage%2Famazonprimevideo.png&w=256&q=75",
  ],
  [
    "HBO Max",
    "https://screenify.fun/_next/image?url=https%3A%2F%2Fstreamanflow.one%2FstudioImage%2Fhbomax.jpg&w=256&q=75",
  ],
  [
    "Disney+",
    "https://screenify.fun/_next/image?url=https%3A%2F%2Fstreamanflow.one%2FstudioImage%2Fdisney%2B.png&w=256&q=75",
  ],
  ["Apple TV+", "https://streamanflow.one/studioImage/appletv+.svg"],
  // [
  //   "paramount+",
  //   "https://streamanflow.one/studioImage/paramount.svg",
  // ],
  // ["hulu", "https://streamanflow.one/studioImage/hulu.svg"],
  // ["starz", "https://screenify.fun/_next/static/media/starz.1e06c497.svg"],
  // ["acorn", "https://screenify.fun/_next/static/media/acorn-tv.61174a3d.svg"],
]);

export const res_yellowColor = "rgba(250,255,0,1)";
export const res_backgroundColor = "rgba(13, 20, 31, 1)";
export const res_blackColor = "rgba(6, 7, 17, 1)";

// Common strings
export function res_appname(): string { return getTranslations().appname; }

// User informing strings
export function res_error_server(): string { return getTranslations().error_server; }
export function res_info_loading_wait(): string { return getTranslations().info_loading_wait; }
export function res_coming_soon(): string { return getTranslations().coming_soon; }
export function res_check_internet_headline(): string { return getTranslations().check_internet_headline; }
export function res_check_internet(): string { return getTranslations().check_internet; }
export function res_need_to_sign_in(): string { return getTranslations().need_to_sign_in; }

//Pages strings
export function res_home(): string { return getTranslations().home; } // for menuItem, content root headline
export function res_serials(): string { return getTranslations().serials; } // for menuItem, content root headline
export function res_movies(): string { return getTranslations().movies; } // for menuItem, content root headline
export function res_collections(): string { return getTranslations().collections; } // for menuItem, content root headline
export function res_charts(): string { return getTranslations().charts; } // for menuItem, content root headline

//Home page strings
export function res_studios(): string { return getTranslations().studios; } // for studios page headline

//Movie page strings
export function res_you_may_also_like(): string { return getTranslations().you_may_also_like; }
export function res_information(): string { return getTranslations().information; }
export function res_year(): string { return getTranslations().year; }
export function res_imdb_rating(): string { return getTranslations().imdb_rating; }
export function res_country(): string { return getTranslations().country; }
export function res_director(): string { return getTranslations().director; }
export function res_no_info(): string { return getTranslations().no_info; }

//Serial page strings
export function res_season(): string { return getTranslations().season; }
export function res_episodes(): string { return getTranslations().episodes; }
export function res_choose_season(): string { return getTranslations().choose_season; }
export function res_seasons(): string { return getTranslations().seasons; }
export function res_search(): string { return getTranslations().search; }

//Fiction page strings
export function res_audio_tracks(): string { return getTranslations().audio_tracks; }
export function res_subtitles(): string { return getTranslations().subtitles; }
export function res_description(): string { return getTranslations().description; }
export function res_watch_now(): string { return getTranslations().watch_now; }

//Account page strings
export function res_screenify_user(): string { return getTranslations().screenify_user; }
export function res_account(): string { return getTranslations().account; } // for menuItem, content root headline
export function res_sign_in(): string { return getTranslations().sign_in; } // for content page headline, for button
export function res_email(): string { return getTranslations().email; } // for title of email input
export function res_email_headline(): string { return getTranslations().email_headline; } // for email input placeholder & on password input page
export function res_password(): string { return getTranslations().password; } // for title of password input
export function res_password_headline(): string { return getTranslations().password_headline; } // for password input placeholder & on password input page

//Search page strings
export function res_all_in_one(): string { return getTranslations().all_in_one; }
export function res_total_films_and_series(): string { return getTranslations().total_films_and_series; }
export function res_click_to_search(): string { return getTranslations().click_to_search; }
export function res_search_for(): string { return getTranslations().search_for; }
export function res_no_results(): string { return getTranslations().no_results; }
export function res_more(): string { return getTranslations().more; }
export function res_search_results_for(): string { return getTranslations().search_results_for; }
export function res_search_total(): string { return getTranslations().search_total; }

//Menu strings
export function res_tv(): string { return getTranslations().tv; }
